import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Check } from 'lucide-react';
import { Button } from '../../../../ui/components/Common/Buttons/Button';
import { MOCK_ORGANIZATION_ROLES } from '../constants';

export const PermissionsTab: React.FC = () => (
  <Stack spacing={4}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 900, color: 'text.primary', letterSpacing: '-0.03em', mb: 0.5 }}>
          Roles & Permissions
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
          Define what members can see and do within the organization.
        </Typography>
      </Box>
      <Button
        label="Create New Role"
        variant="secondary"
        sx={{ borderRadius: 3, px: 3, py: 1.25, fontWeight: 700, borderColor: "#a7f3d0", color: "#059669", "&:hover": { bgcolor: "rgba(236, 253, 245, 0.5)" } }}
      />
    </Box>

    <Stack spacing={3}>
      {MOCK_ORGANIZATION_ROLES.map((role) => (
        <Paper
          key={role.name}
          variant="outlined"
          sx={{
            p: { xs: 3, md: 4 },
            borderRadius: 4,
            transition: 'box-shadow 0.2s',
            '&:hover': { boxShadow: 2 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', lg: 'row' },
              justifyContent: 'space-between',
              alignItems: { lg: 'center' },
              gap: 3,
              mb: 4,
            }}
          >
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary', letterSpacing: '-0.01em' }}>
                  {role.name}
                </Typography>
                <Chip
                  label={`${role.users} Users`}
                  size="small"
                  color="success"
                  variant="outlined"
                  sx={{
                    fontWeight: 800,
                    fontSize: '0.625rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    borderRadius: 2,
                    height: 22,
                  }}
                />
              </Box>
              <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 640 }}>
                {role.description}
              </Typography>
            </Box>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Button
                label="Edit Role"
                variant="secondary"
                sx={{ borderRadius: 3, px: 2.5, py: 1, fontSize: "0.75rem", fontWeight: 700, borderColor: "#e2e8f0" }}
              />
              {role.name !== 'Owner' && (
                <Button
                  label="Duplicate"
                  variant="link"
                  sx={{ color: "#94a3b8", fontWeight: 700, fontSize: "0.75rem" }}
                />
              )}
            </Stack>
          </Box>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {role.permissions.map((permission) => (
              <Chip
                key={permission}
                icon={<Check size={14} color="#10b981" />}
                label={permission}
                size="small"
                sx={{
                  bgcolor: 'action.hover',
                  fontWeight: 600,
                  fontSize: '0.6875rem',
                  borderRadius: 2,
                  py: 1.5,
                  px: 0.5,
                  '& .MuiChip-icon': { ml: 0.75 },
                }}
              />
            ))}
          </Box>
        </Paper>
      ))}
    </Stack>
  </Stack>
);
